import React, { FunctionComponent, memo, ReactElement } from 'react'
import withTheme from '@sport1/react-elements/withTheme'
import { TestID } from '../../utils/PropTypesDefinitions'
import { ThemeProps } from '../../Theme/ThemeComponentTypes'
import { shouldRenderNextImage } from '../../utils/NextHelper'
import { AspectRatioTypes, ExtendedRadiusType, ImageSizeTypes, TintColor } from './ImageInterfaces'
import BaseImage from './BaseImage'
import NextImage from './NextImage'

// ImageBaseProps & ImageProps are used by NextImage
export type ImageBaseProps = {
    imageUrl?: string
    /** info about imageUrl for seo */
    alt?: string
    title?: string
    /** first viewport elements need to have as few repaints as possible */
    webIsInFirstViewport?: boolean
}

export type ImageSizeProps = {
    width?: string | number
    size: ImageSizeTypes
    radiusType?: ExtendedRadiusType
    aspectRatio?: AspectRatioTypes
    resizeMode?: 'cover' | 'contain'
    //TODO: https://sport1digital.atlassian.net/browse/ML-4550 needs to be refactored
    ignoreAspectRatio?: boolean
    height?: number | string
}

export type ImageProps = ImageBaseProps &
    ImageSizeProps &
    TestID & {
        maxHeight?: string | number
        blurRadius?: number
        tintColor?: TintColor
    } & ThemeProps

const Image = (props: ImageProps): ReactElement => {
    const {
        imageUrl,
        aspectRatio,
        radiusType,
        alt,
        size,
        width,
        resizeMode,
        title,
        theme,
        height,
        ignoreAspectRatio,
        webIsInFirstViewport = false,
    } = props

    const isNextImage = shouldRenderNextImage({
        imageUrl,
        aspectRatio,
        radiusType,
        width,
    })

    if (isNextImage) {
        return (
            <NextImage
                {...{
                    imageUrl,
                    aspectRatio,
                    radiusType,
                    alt,
                    size,
                    width,
                    resizeMode,
                    title,
                    theme,
                    ignoreAspectRatio,
                    height,
                    webIsInFirstViewport,
                }}
            />
        )
    }
    return <BaseImage {...props} />
}

export default memo(withTheme(Image)) as FunctionComponent<ImageProps>
